<div class="body">
  <div class="typo-h2 title">{{ "appointmentSelection.appointmentFilters.title" | transloco }}</div>

  @if (appointmentSelectionService.appointmentFiltersForm) {
    <div [formGroup]="appointmentSelectionService.appointmentFiltersForm" class="selection">
      @if (memoryService.employeeId) {
        <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ 'form.label.employee' | transloco }}</mat-label>
          <input [value]="employeeName(memoryService.employeeId)" matInput readonly>
        </mat-form-field>
      }

      @if (appointmentSelectionService.groupedCategorySummaryDtos) {
        <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ 'form.label.category' | transloco }}</mat-label>
          <mat-select (valueChange)="appointmentSelectionService.loadEmployeeSummaryDtos($event)" formControlName="categoryId">
            @for (groupedCategory of appointmentSelectionService.groupedCategorySummaryDtos; track groupedCategory) {
              @if (groupedCategory.categoryGroup) {
                <mat-optgroup [label]="groupedCategory.categoryGroup">
                  @for (categorySummaryDto of groupedCategory.categorySummaryDtos; track categorySummaryDto) {
                    <mat-option [value]="categorySummaryDto.categoryId">
                      {{ categorySummaryDto.name | localizedText }}
                    </mat-option>
                  }
                </mat-optgroup>
              } @else {
                @for (categorySummaryDto of groupedCategory.categorySummaryDtos; track categorySummaryDto) {
                  <mat-option [value]="categorySummaryDto.categoryId">
                    {{ categorySummaryDto.name | localizedText }}
                  </mat-option>
                }
              }
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ 'form.label.category' | transloco }}</mat-label>
          <mat-select disabled/>
        </mat-form-field>
      }

      @if (!memoryService.employeeId) {
        <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ 'form.label.employee' | transloco }}</mat-label>
          @if (appointmentSelectionService.employeeSummaryDtos) {
            <mat-select formControlName="employeeId">
              @for (employeeId of employeeIds; track employeeId) {
                <mat-option [value]="employeeId">
                  @if (employeeId == 0) {
                    {{ 'form.placeholder.any' | transloco }}
                  } @else {
                    <div class="selection-element">
                      @if (employeeImageUrl(employeeId)) {
                        <img [src]="employeeImageUrl(employeeId)" class="avatar">
                      }
                      {{ employeeName(employeeId) }}
                    </div>
                  }
                </mat-option>
              }
            </mat-select>
          } @else {
            <mat-select disabled/>
          }
        </mat-form-field>
      }
    </div>
  } @else {
    <div class="selection">
      @if (memoryService.employeeId) {
        <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ 'form.label.employee' | transloco }}</mat-label>
          <mat-select disabled/>
        </mat-form-field>
      }

      <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
        <mat-label>{{ 'form.label.category' | transloco }}</mat-label>
        <mat-select disabled/>
      </mat-form-field>

      @if (!memoryService.employeeId) {
        <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ 'form.label.employee' | transloco }}</mat-label>
          <mat-select disabled/>
        </mat-form-field>
      }
    </div>
  }

  @if (mobile) {
    <app-text-button (click)="navigateToDateSelection()" [text]="'appointmentSelection.appointmentFilters.button' | transloco" colorVariant="primary" leadingIcon="search" size="big"></app-text-button>
  }
</div>
